<klarna-placement id="klarnaCreditBadge" data-key="credit-promotion-badge" data-locale="en-CA"></klarna-placement>